import React from "react";
import {withTranslation} from "react-i18next";
import i18next from "../../resource/i18n";

class MGroupComp  extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectTap: "team",
        };
    }

    componentDidMount() {
    }

    changeTap = type => () => {
        this.setState({selectTap: type});
    }

    render() {
        const {t} = this.props;
        let rLink = "https://docs.google.com/forms/d/e/1FAIpQLSdytO-oLRpFeMrLTQ_XGfo3Ea1faOzXRaV25_cOZE1o0E-CEQ/viewform?usp=sf_link"
		if (i18next.language === "en" ) {
			rLink = "https://docs.google.com/forms/d/e/1FAIpQLSeMnEp8ZXUSvK7EVHHj5pAc4Q3rRoZ18U09tbFc0tDvKTwfvw/viewform"
		}
        return (
            <div className="content-wrap sub-content">
                <div className="visual-slide-wrap">
                    <div className="visual-slide-list">
                        <div className="slide">
                            <div className="img">
                                <img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_activity_main.png" alt="GROUP ACTIVITIES"/>
                            </div>
                        </div>          
                    </div>
                    
                    <div className="visual-slide-text">
                        <div className="inner">
                            <div className="con">
                                <div className="text-wrap color1">
                                    <p className="s-text typo1">{t('Group_visual_title')}</p>
                                    <p className="m-text">{t('Group_visual_desc')}</p>
                                </div>
                            </div>  
                        </div>  
                    </div>
                </div>
                <div className="detail-con-wrap">
                    <div className="inner">
                        <div className="list list-type6">
                            <div className="tab-wrap">
                                <ul className="tab-menu">
                                    <li style={{width: "20%"}}><button onClick={this.changeTap("team")} className={((this.state.selectTap === "team") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Group_tab_1')}</button></li>
                                    <li style={{width: "20%"}}><button onClick={this.changeTap("mice")} className={((this.state.selectTap === "mice") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Group_tab_2')}</button></li>
                                    <li style={{width: "20%"}}><button onClick={this.changeTap("camp")} className={((this.state.selectTap === "camp") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Group_tab_3')}</button></li>
                                    <li style={{width: "20%"}}><button onClick={this.changeTap("visit")} className={((this.state.selectTap === "visit") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Group_tab_4')}</button></li>
                                    <li style={{width: "20%"}}><button onClick={this.changeTap("custom")} className={((this.state.selectTap === "custom") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Group_tab_5')}</button></li>
                                </ul>
                                <div className="tab-con-wrap">
                                    <div className="tab-con" style={{display: (this.state.selectTap === "team") ? "block" : "none"}}>
                                        <div className="con">
                                            <div className="img">
                                                <img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_activity_sub_teambuilding.png" alt="TEAM BUILDING"/>
                                            </div>
                                        </div>
                                        <div className="list-con">
                                            <div className="list-txt list-txt-type1">
                                                <p className="ttl">{t('Group_tab_1_title')}</p>
                                                <ul>
                                                    <li>
                                                        <p className="txt">
                                                            <span>{t('Group_tab_1_desc_1')}</span><br/>
                                                            <span>{t('Group_tab_1_desc_2')}</span><br/>
                                                            <span className="ps-txt pl-10">{t('Group_tab_1_desc_3')}</span>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-con" style={{display: (this.state.selectTap === "mice") ? "block" : "none"}}>
                                        <div className="con">
                                            <div className="img">
                                                <img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_activity_sub_mice.png" alt="MICE"/>
                                            </div>
                                        </div>
                                        <div className="list-con">
                                            <div className="list-txt list-txt-type1">
                                                <p className="ttl">{t('Group_tab_2_title')}</p>
                                                <ul>
                                                    <li>
                                                        <p className="txt">
                                                            <span>{t('Group_tab_2_desc_1')}</span><br/>
                                                            <span>{t('Group_tab_2_desc_2')}</span><br/>
                                                            <span>{t('Group_tab_2_desc_3')}</span><br/>
                                                            <span className="ps-txt pl-10">{t('Group_tab_2_desc_4')}</span>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-con" style={{display: (this.state.selectTap === "camp") ? "block" : "none"}}>
                                        <div className="con">
                                            <div className="img">
                                                <img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_activity_sub_playcamp.png" alt="PLAY CAMP"/>
                                            </div>
                                        </div>
                                        <div className="list-con">
                                            <div className="list-txt list-txt-type1">
                                                <p className="ttl">{t('Group_tab_3_title')}</p>
                                                <ul>
                                                    <li>
                                                        <p className="txt">
                                                            <span>{t('Group_tab_3_desc_1')}</span><br/>
                                                            <span>{t('Group_tab_3_desc_2')}</span><br/>
                                                            <span>{t('Group_tab_3_desc_3')}</span>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-con" style={{display: (this.state.selectTap === "visit") ? "block" : "none"}}>
                                        <div className="con">
                                            <div className="img">
                                                <img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_activity_sub_innovationtour.png" alt="INNOVATION TOUR"/>
                                            </div>
                                        </div>
                                        <div className="list-con">
                                            <div className="list-txt list-txt-type1">
                                                <p className="ttl">{t('Group_tab_4_title')}</p>
                                                <ul>
                                                    <li>
                                                        <p className="txt">
                                                            <span>{t('Group_tab_4_desc_1')}</span><br/>
                                                            <span>{t('Group_tab_4_desc_2')}</span><br/>
                                                            <span>{t('Group_tab_4_desc_3')}</span>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-con" style={{display: (this.state.selectTap === "custom") ? "block" : "none"}}>
                                        <div className="con">
                                            <div className="img">
                                                <img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_activity_sub_customize.png" alt="CUSTOMIZE"/>
                                            </div>
                                        </div>
                                        <div className="list-con">
                                            <div className="list-txt list-txt-type1">
                                                <p className="ttl">{t('Group_tab_5_title')}</p>
                                                <ul>
                                                    <li>
                                                        <p className="txt">
                                                            <span>{t('Group_tab_5_desc_1')}</span><br/>
                                                            <span>{t('Group_tab_5_desc_2')}</span><br/>
                                                            <span>{t('Group_tab_5_desc_3')}</span>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="list list-type9">
                            <div className="list-con">
                                <p className="lg-ttl">{t('Group_sub_c2')}</p>
                                <div className="list-txt">                      
                                    <ul>
                                        <li>
                                            <p className="txt txt-indent">
                                                {t('Group_sub_c3')} <br/> 
                                                <span className="hyphen">{t('Group_sub_c3_1')}</span><br/>                                                
                                                <span className="hyphen">{t('Group_sub_c5')}<a href={rLink} target="_blank" className="link" rel="noopener noreferrer">{t('Group_sub_c5_1')}</a></span>
                                            </p>
                                        </li>
                                        <li><p className="txt">{t('Group_sub_c6')}</p></li>
                                        <li><p className="txt">{t('Group_sub_c7')}</p></li>
                                    </ul>
                                    <p className="txt ps-txt">
                                        <span>{t('Group_sub_c8_1')}</span><br/>
                                        <span>{t('Group_sub_c8_2')}</span><br/>
                                        <span>{t('Group_sub_c8_3')}</span><br/>
                                        <span>{t('Group_sub_c8_4')}</span>
                                    </p>
                                </div>
                            </div>                  
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withTranslation()(MGroupComp);
